export function promiseWithTimeout<T>(
  executor: (
    resolve: (value: T | PromiseLike<T>) => void,
    reject: (reason?: unknown) => void,
  ) => void,
  options: {
    timeoutMs: number;
    timeoutError: Error;
  },
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(options.timeoutError);
    }, options.timeoutMs);

    const wrappedResolve = (value: T | PromiseLike<T>) => {
      clearTimeout(timeoutId);
      resolve(value);
    };

    const wrappedReject = (reason?: unknown) => {
      clearTimeout(timeoutId);
      reject(reason);
    };

    executor(wrappedResolve, wrappedReject);
  });
}
